{
  "failed_fetch_profile": "Misslyckades att hämta profildata",
  "failed_update_profile": "Misslyckades att uppdatera profildata",
  "account_information": "Kontoinformation",
  "language": "Språk",
  "member_since": "Medlem sedan",
  "account_status": "Kontostatus",
  "profile_complete": "Profil komplett",
  "delete_account": "Radera konto",
  "delete_user_account": "Radera användarkonto",
  "delete_account_warning": "När du raderar ditt konto finns det ingen återvändo. Var säker.",
  "delete_user_warning": "Detta kommer permanent radera denna användares konto. Denna åtgärd kan inte ångras.",
  "delete_user": "Radera användare",
  "really_delete": "Verkligen radera? ({seconds})",
  "edit_information": "Redigera information",
  "edit_profile": "Redigera profil",
  "choose_language": "Välj språk",
  "security": "Säkerhet",
  "security_coming_soon": "Säkerhetsinställningar kommer snart",
  "delete_confirmation": "Är du säker på att du vill ta bort ditt användarkonto?",
  "delete_warning": "Denna åtgärd kan inte ångras.",
  "email": "E-post",
  "password": "Lösenord",
  "current_password": "Nuvarande lösenord",
  "new_password": "Nytt lösenord",
  "confirm_new_password": "Bekräfta nytt lösenord",
  "change_password": "Ändra lösenord",
  "password_changed_successfully": "Lösenordet har ändrats",
  "birth_year": "Födelseår",
  "date_of_birth": "Födelsedatum",
  "date_of_birth_help": "Krävs för åldersbegränsade tävlingar",
  "profile_image": "Profilbild",
  "upload_profile_image": "Ladda upp profilbild",
  "change_profile_image": "Ändra profilbild",
  "remove_profile_image": "Ta bort profilbild",
  "profile_image_uploaded": "Profilbild uppladdad",
  "profile_image_removed": "Profilbild borttagen",
  "upload_image_hint": "Klicka eller dra och släpp en bild här. Max 5MB. Endast JPEG, PNG eller WebP.",
  "uploading_image": "Laddar upp bild...",
  "removing_image": "Tar bort bild...",
  "failed_to_upload_image": "Misslyckades att ladda upp profilbild",
  "failed_to_remove_image": "Misslyckades att ta bort profilbild",
  "invalid_file_type": "Ogiltig filtyp. Endast JPEG, PNG och WebP-bilder är tillåtna",
  "file_size_exceeded": "Filstorleken överskrider maxgränsen på 5MB",
  "preferred_units": "Föredragen måttenhet",
  "preferred_units_help": "Välj om du vill se fairwaylängder i meter eller yards",
  "preferences": {
    "title": "Inställningar",
    "track_statistics": "Spåra rundstatistik",
    "track_statistics_description": "Samla in detaljerad statistik (fairway, green, puttar, etc.) från dina rundor",
    "prompt_course_conditions": "Fråga efter banförhållanden efter runda",
    "prompt_course_conditions_description": "När du avslutar en runda kommer du att bli ombedd att ange banförhållanden (väder, greenhastighet, etc.)",
    "statsCollection": {
      "perStat": {
        "putts": "Puttar",
        "chips": "Chippar",
        "bunkerShots": "Bunkerslag",
        "penaltyStrokes": "Straffslag",
        "firstPutt": "Första putten",
        "holedPutt": "Hålad putt",
        "gir": "Green i reglage",
        "fir": "Fairway i reglage"
      }
    }
  },
  "units": {
    "metric": "Meter",
    "imperial": "Yards"
  },
  "confirm_remove_profile_image": "Vill du verkligen ta bort profilbilden?",
  "crop_profile_image": "Beskär profilbild",
  "zoom": "Zooma",
  "golfid_fields_info": "Ditt konto är kopplat till GolfID. Namn, kön, handikapp och födelsedatum uppdateras automatiskt från Golfförbundets register.",
  "golf_id": {
    "section_title": "Koppla Suomi Golf ID",
    "section_title_linked": "Suomi Golf ID",
    "linked": "Kopplad",
    "link_button": "Koppla Suomi Golf ID",
    "username_label": "Suomi Golf ID-användarnamn",
    "username_placeholder": "Suomi Golf ID eller e-postadress",
    "password_label": "Lösenord",
    "password_placeholder": "Lösenord",
    "linking": "Kopplar...",
    "link_success": "Golf ID kopplat",
    "error_invalid_credentials": "Ogiltigt användarnamn eller lösenord",
    "error_already_linked": "Kontot är redan kopplat till ett Golf ID",
    "error_taken": "Detta Golf ID är redan kopplat till ett annat konto",
    "error_unavailable": "Golf ID-tjänsten är inte tillgänglig",
    "error_challenge": "Golf ID kräver ytterligare verifiering",
    "description": "Genom att koppla dina konton får du ett aktuellt handikapp och kan skicka resultat till den officiella handikappberäkningen.",
    "privacy_notice": "Dina Suomi Golf ID-uppgifter används bara för koppling och sparas inte.",
    "forgot_password": "Glömt lösenord?",
    "error_invalid_format": "Det ID du angett är inte ett Suomi Golf ID. Du hittar ditt Suomi Golf ID i inställningarna i eBirdie-appen."
  },
  "payment_history": {
    "title": "Betalningshistorik",
    "no_payments": "Inga betalningar",
    "load_more": "Ladda fler",
    "competition_fee": "Tävlingsavgift",
    "green_fee": "Green fee",
    "load_failed": "Misslyckades att ladda betalningshistorik"
  },
  "round_settings": {
    "private_round": "Privat runda",
    "private_round_description": "En privat runda syns inte för dina vänner"
  },
  "feedback": {
    "row_label": "Skicka feedback till utvecklaren",
    "modal_title": "Feedbackformulär",
    "message_placeholder": "Skriv feedback till tjänstens utvecklare",
    "device_section_title": "Min enhet",
    "device_apple": "Apple (iOS)",
    "device_android": "Android",
    "device_desktop": "Dator",
    "wants_contact_label": "Jag kan kontaktas",
    "submit": "Skicka",
    "sending": "Skickar",
    "cancel": "Avbryt",
    "success": "Feedback skickad",
    "error": "Det gick inte att skicka feedback. Försök igen.",
    "wants_contact_helper": "Kontaktuppgifterna används endast för att svara på din feedback.",
    "images": {
      "label": "Bifoga bilder (valfritt)",
      "optional_suffix": "(valfritt)",
      "cta_mobile": "Lägg till bilder",
      "cta_desktop": "Dra bilder hit eller välj",
      "limit": "Max 3 bilder, 5 MB / bild",
      "errors": {
        "too_large": "Bilden är för stor (max 5 MB)",
        "wrong_format": "Format som stöds: JPEG, PNG, WEBP",
        "too_many": "Du kan lägga till högst 3 bilder"
      },
      "remove_aria": "Ta bort bild"
    }
  },
  "email_change": {
    "title": "Ändra e-postadress",
    "description": "Din nuvarande adress är <strong>{{email}}</strong>. Vi skickar en bekräftelselänk till den nya adressen — adressen ändras först när du bekräftar den.",
    "new_email": "Ny e-postadress",
    "submit": "Skicka bekräftelselänk",
    "confirmation_sent_to": "Bekräftelselänk skickad till <strong>{{email}}</strong>.",
    "confirmation_sent_info": "Din e-postadress ändras när du öppnar länken i meddelandet. Länken är giltig i 24 timmar.",
    "relogin_required": "Logga ut och logga in igen med ditt Google- eller Apple-konto, varefter du kan ändra e-postadressen på ett säkert sätt."
  }
}
